/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AbpPtwExceptionHttpResponseModel,
  HistoryDto,
  JobOccurrenceDto,
  ManualTaskWorkInputDto,
  ManualTaskWorkResultDto,
  ODataPostProcessedResultsOfJobOccurrenceDto,
  ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto,
  UpdateJobOccurrenceDto,
  UpdateWorkStepDto,
} from '../models/index';
import {
    AbpPtwExceptionHttpResponseModelFromJSON,
    AbpPtwExceptionHttpResponseModelToJSON,
    HistoryDtoFromJSON,
    HistoryDtoToJSON,
    JobOccurrenceDtoFromJSON,
    JobOccurrenceDtoToJSON,
    ManualTaskWorkInputDtoFromJSON,
    ManualTaskWorkInputDtoToJSON,
    ManualTaskWorkResultDtoFromJSON,
    ManualTaskWorkResultDtoToJSON,
    ODataPostProcessedResultsOfJobOccurrenceDtoFromJSON,
    ODataPostProcessedResultsOfJobOccurrenceDtoToJSON,
    ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoFromJSON,
    ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoToJSON,
    UpdateJobOccurrenceDtoFromJSON,
    UpdateJobOccurrenceDtoToJSON,
    UpdateWorkStepDtoFromJSON,
    UpdateWorkStepDtoToJSON,
} from '../models/index';

export interface DeleteJobOccurrenceRequest {
    id: string;
}

export interface GetFilterOptionsRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface GetJobOccurrenceRequest {
    id: string;
}

export interface GetJobOccurrenceHistoryRequest {
    id: string;
}

export interface GetJobOccurrenceWithActiveStateRequest {
    id: string;
    isActive?: boolean;
}

export interface GetJobOccurrencesRequest {
    $filter?: string;
    $search?: string;
    $top?: number;
    $skip?: number;
    $orderby?: string;
}

export interface SkipAllWorkItemsRequest {
    id: string;
    workItemID: string;
    skipAll: boolean;
}

export interface StartManualWorkStepRequest {
    id: string;
    workStepId: string;
    evaluationId: string;
    manualTaskWorkInputDto?: ManualTaskWorkInputDto;
}

export interface UpdateJobExecutionRequest {
    id: string;
    updateJobOccurrenceDto?: UpdateJobOccurrenceDto;
}

export interface UpdateWorkStepRequest {
    id: string;
    workStepId: string;
    updateWorkStepDto?: UpdateWorkStepDto;
}

export interface ValidateJobOccurrenceRequest {
    updateJobOccurrenceDto?: UpdateJobOccurrenceDto;
}

/**
 * 
 */
export class JobOccurrencesApi extends runtime.BaseAPI {

    /**
     * Deletes the entity with the given id.
     */
    async deleteJobOccurrenceRaw(requestParameters: DeleteJobOccurrenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteJobOccurrence.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-occurrences/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the entity with the given id.
     */
    async deleteJobOccurrence(requestParameters: DeleteJobOccurrenceRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.deleteJobOccurrenceRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async getFilterOptionsRaw(requestParameters: GetFilterOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-occurrences/filter-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDtoFromJSON(jsonValue));
    }

    /**
     */
    async getFilterOptions(requestParameters: GetFilterOptionsRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getFilterOptionsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfJobOccurrenceFilterOptionsDto>(response, errorHandlers);
    }

    /**
     * Returns one entity for detail view.
     */
    async getJobOccurrenceRaw(requestParameters: GetJobOccurrenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobOccurrenceDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getJobOccurrence.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-occurrences/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => JobOccurrenceDtoFromJSON(jsonValue));
    }

    /**
     * Returns one entity for detail view.
     */
    async getJobOccurrence(requestParameters: GetJobOccurrenceRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getJobOccurrenceRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<JobOccurrenceDto>(response, errorHandlers);
    }

    /**
     */
    async getJobOccurrenceHistoryRaw(requestParameters: GetJobOccurrenceHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HistoryDto>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getJobOccurrenceHistory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-occurrences/{id}/history`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HistoryDtoFromJSON));
    }

    /**
     */
    async getJobOccurrenceHistory(requestParameters: GetJobOccurrenceHistoryRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getJobOccurrenceHistoryRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<Array<HistoryDto>>(response, errorHandlers);
    }

    /**
     */
    async getJobOccurrenceWithActiveStateRaw(requestParameters: GetJobOccurrenceWithActiveStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobOccurrenceDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getJobOccurrenceWithActiveState.');
        }

        const queryParameters: any = {};

        if (requestParameters.isActive !== undefined) {
            queryParameters['isActive'] = requestParameters.isActive;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-occurrences/{id}/details`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => JobOccurrenceDtoFromJSON(jsonValue));
    }

    /**
     */
    async getJobOccurrenceWithActiveState(requestParameters: GetJobOccurrenceWithActiveStateRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getJobOccurrenceWithActiveStateRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<JobOccurrenceDto>(response, errorHandlers);
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getJobOccurrencesRaw(requestParameters: GetJobOccurrencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ODataPostProcessedResultsOfJobOccurrenceDto>> {
        const queryParameters: any = {};

        if (requestParameters.$filter !== undefined) {
            queryParameters['$filter'] = requestParameters.$filter;
        }

        if (requestParameters.$search !== undefined) {
            queryParameters['$search'] = requestParameters.$search;
        }

        if (requestParameters.$top !== undefined) {
            queryParameters['$top'] = requestParameters.$top;
        }

        if (requestParameters.$skip !== undefined) {
            queryParameters['$skip'] = requestParameters.$skip;
        }

        if (requestParameters.$orderby !== undefined) {
            queryParameters['$orderby'] = requestParameters.$orderby;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-occurrences`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ODataPostProcessedResultsOfJobOccurrenceDtoFromJSON(jsonValue));
    }

    /**
     * Returns a list of entities for grid view.
     */
    async getJobOccurrences(requestParameters: GetJobOccurrencesRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.getJobOccurrencesRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ODataPostProcessedResultsOfJobOccurrenceDto>(response, errorHandlers);
    }

    /**
     */
    async skipAllWorkItemsRaw(requestParameters: SkipAllWorkItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling skipAllWorkItems.');
        }

        if (requestParameters.workItemID === null || requestParameters.workItemID === undefined) {
            throw new runtime.RequiredError('workItemID','Required parameter requestParameters.workItemID was null or undefined when calling skipAllWorkItems.');
        }

        if (requestParameters.skipAll === null || requestParameters.skipAll === undefined) {
            throw new runtime.RequiredError('skipAll','Required parameter requestParameters.skipAll was null or undefined when calling skipAllWorkItems.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/job-occurrences/{id}/work-items/{workItemID}/{skipAll}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"workItemID"}}`, encodeURIComponent(String(requestParameters.workItemID))).replace(`{${"skipAll"}}`, encodeURIComponent(String(requestParameters.skipAll))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async skipAllWorkItems(requestParameters: SkipAllWorkItemsRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.skipAllWorkItemsRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     */
    async startManualWorkStepRaw(requestParameters: StartManualWorkStepRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ManualTaskWorkResultDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling startManualWorkStep.');
        }

        if (requestParameters.workStepId === null || requestParameters.workStepId === undefined) {
            throw new runtime.RequiredError('workStepId','Required parameter requestParameters.workStepId was null or undefined when calling startManualWorkStep.');
        }

        if (requestParameters.evaluationId === null || requestParameters.evaluationId === undefined) {
            throw new runtime.RequiredError('evaluationId','Required parameter requestParameters.evaluationId was null or undefined when calling startManualWorkStep.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/job-occurrences/{id}/work-steps/{workStepId}/evaluations/{evaluationId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"workStepId"}}`, encodeURIComponent(String(requestParameters.workStepId))).replace(`{${"evaluationId"}}`, encodeURIComponent(String(requestParameters.evaluationId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ManualTaskWorkInputDtoToJSON(requestParameters.manualTaskWorkInputDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => ManualTaskWorkResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async startManualWorkStep(requestParameters: StartManualWorkStepRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.startManualWorkStepRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<ManualTaskWorkResultDto>(response, errorHandlers);
    }

    /**
     */
    async updateJobExecutionRaw(requestParameters: UpdateJobExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<JobOccurrenceDto>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateJobExecution.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/job-occurrences/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateJobOccurrenceDtoToJSON(requestParameters.updateJobOccurrenceDto),
        }, initOverrides);
        if (runtime.hasEmptyBody(response)) {
            return new runtime.VoidApiResponse(response) as any;
        }
        return new runtime.JSONApiResponse(response, (jsonValue) => JobOccurrenceDtoFromJSON(jsonValue));
    }

    /**
     */
    async updateJobExecution(requestParameters: UpdateJobExecutionRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateJobExecutionRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<JobOccurrenceDto>(response, errorHandlers);
    }

    /**
     */
    async updateWorkStepRaw(requestParameters: UpdateWorkStepRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateWorkStep.');
        }

        if (requestParameters.workStepId === null || requestParameters.workStepId === undefined) {
            throw new runtime.RequiredError('workStepId','Required parameter requestParameters.workStepId was null or undefined when calling updateWorkStep.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/job-occurrences/{id}/work-steps/{workStepId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))).replace(`{${"workStepId"}}`, encodeURIComponent(String(requestParameters.workStepId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateWorkStepDtoToJSON(requestParameters.updateWorkStepDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateWorkStep(requestParameters: UpdateWorkStepRequest, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.updateWorkStepRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateJobOccurrenceRaw(requestParameters: ValidateJobOccurrenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/job-occurrences/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateJobOccurrenceDtoToJSON(requestParameters.updateJobOccurrenceDto),
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validates an entity without adding or updating it.
     */
    async validateJobOccurrence(requestParameters: ValidateJobOccurrenceRequest = {}, errorHandlers?: runtime.ErrorHandlerFunction[], initOverrides?: RequestInit | runtime.InitOverrideFunction) {
        const response = this.validateJobOccurrenceRaw(requestParameters, initOverrides);
        return this.configuration.handleFunction<void>(response, errorHandlers);
    }

}
